/* NOTE:
   It's important to have this line to be imported before lazysizes.
   Otherwise config won't be recognized by lazisizes what leads to race condition and not loaded images.
*/
/* eslint-disable no-unused-vars, import/order */
import _lazySizesConfig from '../utils/lazysizes-config';
import lazySizes from 'lazysizes';
/* eslint-enable no-unused-vars, import/order */
import SocialVideo from './media-loaders/social-video';
import VideoLoader from './media-loaders/video';
import ImageLoader from './media-loaders/image';
import BackgroundImageLoader from './media-loaders/background-image';
import { SOCIAL_VIDEO_CONTAINER } from '../classnames/video';

export default class MediaLoader {
  videoLoader = new VideoLoader();
  imageLoader = new ImageLoader();
  backgroundImageLoader = new BackgroundImageLoader();

  initialize = (container = document) => {
    this.videoLoader.initialize(container);

    [...container.querySelectorAll(`.${SOCIAL_VIDEO_CONTAINER}`)]
      .forEach((elem) => new SocialVideo(elem).initialize());

    this.imageLoader.initialize(container);
    this.backgroundImageLoader.initialize(container);
    lazySizes.init();
  };
}
